import React, { useState } from 'react'
import { cellRendererCheck, dateFormate } from 'utils/columns';
import ReactStrapTable from 'components/reactStrapTable';
import Loader from 'components/Loader';
import CellOptions from 'components/reactStrapTable/components/CellOptions';
import useAxios from 'hooks/useAxios';
import { cloneDeep } from 'lodash';

const PendingChargesTable = (props) => {
  const { orgId, setLoading, loading, utilizationData,utilizationDataRecords,purchaseHistoryinstialValues,
    setUtilizationData, setUtilizationDataRecords,selectedutilizationData,
                setSelectedUtilizationData } = props;
                const API=useAxios()
  const [tableData, setTableData] = useState([])
  const handelClickimage = () => {
    setChargeCodeflag(false)
  };
   const dateFormateTime = (value) => {
    if (!value) return '-';
    const date = new Date(value);
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    };
    const data1 = date !== null ? date?.toLocaleString('en-US', options).replace(",", "").replace(/\//g, "/") : "-"
    return data1;
  };
console.log(purchaseHistoryinstialValues,"purchaseHistoryinstialValues")
  
  let mainCol = [
  {
    dataField: "edit",
    text: "Options",
    width: 60,
    show: true,
    disabled: true,
    hideColFilter: true,
    action: true,
  },
  {
      dataField: "drugAdminDate",
      text: "Date of Drug Administration",
      sort: false,
      width: 100,
      show: true,
      inputType: "date",
      hideColFilter: false,
    cellRenderer: (row) => dateFormateTime(row.drugAdminDate),
    },
  {
    dataField: "dispensedQuantity",
    text: "Dispensed Qty",
    sort: false,
    width: 80,
    show: true,
    inputType: "text",
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.dispensedQuantity),
  },
  {
    dataField: "patientType",
    text: "Patient Type",
    sort: false,
    width: 180,
    show: true,
    inputType: "text",
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.patientType),
  },
  {
    dataField: "location",
    text: "Location",
    sort: false,
    width: 110,
    show: true,
    edit: true,
    inputType: "text",
    hideColFilter: false,
    cellRenderer: (row, col) => cellRendererCheck(row.location),
  },
  {
    dataField: "visitNumber",
    text: "Visit #",
    sort: false,
    width: 55,
    show: true,
    inputType: "number",
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.visitNumber),
  },
  {
    dataField: "mrNumber",
    text: "MRN #",
    sort: false,
    width: 55,
    show: true,
    inputType: "number",
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.mrNumber),
  },
];

  const fetchutilizationHistory = async (selectedutilizationData,purchaseHistoryinstialValues) => {
    debugger;
    let chargeId = selectedutilizationData?.chargeID
    setLoading(true);
    try {
      const { data } = await API.post(
        `SBTenant/${orgId.tenantID}/Crosswalk/ChargeCodeUtilizationHistory/${chargeId}`,purchaseHistoryinstialValues,
        {
          hasDefaultURL: true,
        }
      );
      if (data?.items?.length > 0) {
        setUtilizationData(data.items);
        setUtilizationDataRecords(data.totalRecords);   
         setLoading(false);
      }
      else{
        setLoading(false);
        setUtilizationData([]);        
        setUtilizationDataRecords(0);
      }
    } catch {
      setLoading(false);
    }
  }
 
    const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
      debugger;
      purchaseHistoryinstialValues.currentPage = cloneDeep(filter.currentPage);
      if (hasColFilter) {
        const colFilterOn = { ...filter, filters: colChangedFilter };
        onPageChange(colFilterOn, true);
      } else {
        onPageChange(purchaseHistoryinstialValues);
      }
    };
    const onPageChange = (filter, haveColFilter) => {
        debugger;
        if (haveColFilter) {
          const filterObj = cloneDeep(purchaseHistoryinstialValues);
          filterObj.filters = [...filterObj.filters, ...filter.filters];
          filterObj.currentPage = filter.currentPage;
          filterObj.pageSize = filter.pageSize;
          debugger;
          fetchutilizationHistory(selectedutilizationData,purchaseHistoryinstialValues);
        } else {
          debugger;
          purchaseHistoryinstialValues.currentPage=filter.currentPage
          purchaseHistoryinstialValues.pageSize=filter.pageSize
          fetchutilizationHistory(selectedutilizationData,purchaseHistoryinstialValues);
        }
      };
   const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {

    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    onPageChange(filter);
  };
  // console.log(utilizationDataRecords,"utilizationDataRecords")
  return (
    <div>
      {/* {loading && <Loader opacity={0.01} />} */}
      <div>
        <h3 className='f-16 font-weight-600' style={{ color: "#702C62" }}>Pending Charges({utilizationDataRecords})

        </h3>
      </div>
      <div
        className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={utilizationDataRecords?.length > 0 ? "fixed-height" : "default"}
      >
        <ReactStrapTable
          id="chargecode-pendingtable"
          height={550}
          fixedColumn
          width={1200}
            hasPagination
          // reset={reset}
          data={utilizationData}
          columns={mainCol}
          onPageChange={onHandlePageChange}
          onPageSizeChange={onPageSizeChange}
          filters={purchaseHistoryinstialValues}
        totalRecords={utilizationDataRecords}
            pageSize={purchaseHistoryinstialValues?.pageSize}
            currentPage={purchaseHistoryinstialValues?.currentPage}
            hidefilter={true}


          // showtoggle={true}

        />

      </div>
    </div>
  )
}

export default PendingChargesTable